// alertsList renders through editList's template (alertsList.php sets
// $template = 'editList') and has no client behaviour of its own. Now that
// editList.tpl stamps data-zit-component with the component's shortName
// ('alertsList') rather than a hardcoded 'editList', this shim maps that
// shortName to editList's JS so add/remove/collapse keep working.
module.exports = require('../editList/editList');
